const demo = {
  SITE_URL: 'https://jobswidget.deliveryweb.ru',
  API_URL: 'https://jobswidget.deliveryweb.ru/api/v1/',
  WEBSOCKET_URL: 'wss://jobswidget.deliveryweb.ru/ws',
};

export { demo as default };
